var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testing__comment block__content"},[_c('div',{staticClass:"testing__comment-title mb-5"},[_vm._v("Комментарий")]),_c('div',{staticClass:"testing__comment-text"},[_vm._v(" "+_vm._s(_vm.test.Description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }